import {
  IEvaluationsAssetItem,
  IFileUploadData,
  IFormattedAssetItem,
  IFormattedMediaItem,
} from '@northladder/services';

/**
 * Format the response of the evaluation details.
 */
export function formatEvaluationsDetailsResponse(
  data: IEvaluationsAssetItem
): IFormattedAssetItem {
  const { images, ...rest } = data || {};
  const formattedImages: IFormattedMediaItem = {
    other: [],
  };

  images.forEach((image) => {
    const { fileName, filePath, thumbnailPath, metadata } = image;
    const imgId = metadata?.imageIdentifier;

    const formattedImage: IFileUploadData = {
      baseUrl: '',
      fileName,
      filePath,
      thumbnailPath,
    };

    if (imgId) {
      if (!formattedImages[imgId]) {
        formattedImages[imgId] = [];
      }

      formattedImages?.[imgId]?.push({
        fileName,
        uploadedFileData: formattedImage,
      });
    } else {
      formattedImages.other?.push({
        fileName,
        uploadedFileData: formattedImage,
      });
    }
  });

  return {
    ...rest,
    images: formattedImages,
  };
}
